<ng-container [ngSwitch]="inputType">
  <!-- Number input -->
  <mat-form-field *ngSwitchCase="inputTypes.Number" appearance="outline" class="full-width">
    <input
      matInput
      type="number"
      [ngModel]="value"
      (ngModelChange)="updateValue($event)"
      [attr.min]="min !== undefined ? min : null"
      [attr.max]="max !== undefined ? max : null"
      [step]="step"
      [disabled]="disabled" />
  </mat-form-field>

  <!-- Slider input -->
  <div *ngSwitchCase="inputTypes.Slider" class="slider-container">
    <mat-slider
      [min]="min ?? 0"
      [max]="max ?? 100"
      [step]="step"
      [disabled]="disabled"
      [displayWith]="displaySliderLabel"
      class="full-width">
      <input matSliderThumb [ngModel]="value" (ngModelChange)="updateValue($event)" />
    </mat-slider>

    <div class="slider-ticks" *ngIf="sliderTickMarks.length > 0">
      <span *ngFor="let tick of sliderTickMarks" class="tick-label">{{ tick }}</span>
    </div>
  </div>

  <!-- Radio group -->
  <div *ngSwitchCase="inputTypes.RadioGroup" class="radio-group-container">
    <mat-radio-group 
      [ngModel]="value" 
      (ngModelChange)="updateValue($event)" 
      [disabled]="disabled" 
      [ngClass]="{'radio-group': true, 'horizontal-radio-group': !guideVisible, 'vertical-radio-group': guideVisible}">
      <mat-radio-button
        *ngFor="let option of sortedOptions; trackBy: trackByOptionValue"
        [value]="option.value"
        class="radio-button">
        <span class="radio-label">
          <span class="option-label">{{ option.label }}</span>
          <!-- Beschreibung nur anzeigen, wenn der Guide sichtbar ist -->
          <span *ngIf="option.description && guideVisible" class="option-description">- {{ option.description }}</span>
        </span>
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <!-- Dropdown -->
  <mat-form-field *ngSwitchCase="inputTypes.Dropdown" appearance="outline" class="full-width">
    <mat-select
      [ngModel]="value"
      (ngModelChange)="updateValue($event)"
      [disabled]="disabled"
      [compareWith]="compareOptionValues">
      <mat-option *ngFor="let option of sortedOptions; trackBy: trackByOptionValue" [value]="option.value">
        {{ option.label }}
        <span *ngIf="option.description" class="option-description"> - {{ option.description }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Timer -->
  <div *ngSwitchCase="inputTypes.Timer" class="timer-container">
    <div class="timer-display">{{ value | number: '1.1-1' }} s</div>
    <div class="timer-controls">
      <button mat-raised-button color="primary" (click)="startTimer()" [disabled]="timerRunning || disabled">
        <mat-icon>play_arrow</mat-icon> Start
      </button>
      <button mat-raised-button color="warn" (click)="stopTimer()" [disabled]="!timerRunning || disabled">
        <mat-icon>stop</mat-icon> Stop
      </button>
      <button mat-raised-button (click)="resetTimer()" [disabled]="disabled"><mat-icon>refresh</mat-icon> Reset</button>
    </div>
  </div>

  <!-- Checkbox -->
  <mat-checkbox
    *ngSwitchCase="inputTypes.Checkbox"
    [ngModel]="value"
    (ngModelChange)="updateValue($event)"
    [disabled]="disabled">
    {{ options && options.length > 0 ? options[0].label : '' }}
  </mat-checkbox>

  <!-- Special inputs (fallback to number) -->
  <mat-form-field *ngSwitchDefault appearance="outline" class="full-width">
    <input
      matInput
      type="number"
      [ngModel]="value"
      (ngModelChange)="updateValue($event)"
      [attr.min]="min !== undefined ? min : null"
      [attr.max]="max !== undefined ? max : null"
      [step]="step"
      [disabled]="disabled" />
  </mat-form-field>
</ng-container>
